import { Popover, PopoverContent, PopoverHandler } from "@material-tailwind/react";
import Avatar from "../../design-system/Avatar";
import { ArrowRightOnRectangleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { logoutUsers } from "../../api/axiosInstanceApi";
import { useState } from "react";
import { UserDetailsObjectProps } from "./Layout";
import { useNavigate } from "react-router-dom";
const UserProfileIcon = ({ userDetails }: UserDetailsObjectProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const navigate = useNavigate();
  const getInitials = (name: string | null) => {
    return name
      ?.split(" ")
      .map(n => n[0])
      .join("");
  };
  const initials = getInitials(userDetails.userName);
  const handleLogout = async () => {
    localStorage.removeItem("mentee_data");
    await logoutUsers();
    navigate("/login");
  };
  const handleResetPassword = () => {
    setIsPopoverOpen(!isPopoverOpen);
    navigate("/change-password");
  };
const isNotLinkedin = userDetails.loginType !== "linkedin";
const isNotGoogle = userDetails.loginType !== "google";
  return (
    <>
      <div className=" min-w-10">
        <Popover open={isPopoverOpen} handler={() => setIsPopoverOpen(!isPopoverOpen)} placement="bottom-end">
          <PopoverHandler>
            <div className="cursor-pointer">
              <Avatar initials={initials} fullName={userDetails.userName} />
            </div>
          </PopoverHandler>
          <PopoverContent className="m-2 z-50 card_bg_color w-60 sm:w-80 min-w-60 h-auto p-4 rounded-lg shadow-lg">
            <div className="flex justify-end mb-4">
              <button onClick={() => setIsPopoverOpen(false)} aria-label="Close">
                <XMarkIcon className="w-6 h-6 text-gray-300 hover:text-gray-500" />
              </button>
            </div>
            <div className="flex flex-col items-center">
              <Avatar
                initials={initials}
                fullName={userDetails.userName}
                className="w-14 h-14 font-bold text-2xl mb-2 border-2 border-gray-300 rounded-full"
              />
              <h3 className="text-lg font-medium card_text_color">{userDetails.userName} </h3>
              <p className="text-sm text-gray-300">{userDetails.userEmail}</p>
            </div>
            <div className="mt-6 space-y-2">
              <button
                onClick={handleLogout}
                className="w-full flex items-center justify-center px-4 py-2 text-white bg-red-800 rounded-lg hover:bg-red-700"
              >
                <ArrowRightOnRectangleIcon className="h-5 w-5 mr-2" />
                Sign Out
              </button>
              {(isNotLinkedin  && isNotGoogle) ? (
                <button
                  onClick={handleResetPassword}
                  className="w-full flex items-center justify-center px-4 py-2 text-white bg-blue-700 rounded-lg hover:bg-blue-600"
                >
                  Change Password
                </button>
              ):("")}
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </>
  );
};

export default UserProfileIcon;
